/* eslint-disable prettier/prettier */
/* eslint-disable arrow-parens */
/* eslint-disable react/prop-types */
import { useState, forwardRef, useCallback, useContext, Suspense, useRef, useEffect } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { api } from "../../../../../utils/api";
import { ThemeContext } from "../../../../../contexts";
import { AuthContext } from "../../../../../contexts";
import { Grid, DialogContent, DialogActions, Slide, Button } from "@mui/material";
import { CustomInput } from "../../../../shared/CustomInput";
import { isVariableDeclarationList } from "typescript";
import { LINK, port, url } from "../../../../../config/config";
import axios from "axios";
import { trackPromise } from "react-promise-tracker";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const ContactEditDialog = ({ dialogProps, handleClose, member, setMember }) => {
	const { openDialog, actions } = dialogProps;
	const { theme } = useContext(ThemeContext);
	const [isEnrollment, setIsEnrollment] = useState(false);
	const [editContactInformation, setEditContactInformation] = useState({
		// email: "",
		address_line_1: "",
		address_line_2: ""
	});

	const handleEditContactInformationChange = useCallback(
		(event) => {
			const { name, value } = event.target;
			setEditContactInformation(Object.assign({}, editContactInformation, { [name]: value }));
		},
		[editContactInformation]
	);

	const handleEditContactSubmitClick = useCallback(async () => {
		const payload = [];
		let _payload = {};
		const { address_line_1, address_line_2 } = editContactInformation;
		if (isEnrollment) {
			if (editContactInformation.address_line_1 !== "") {
				_payload = {
					..._payload,
					address_line_1: editContactInformation.address_line_1
				};
			}
			if (editContactInformation.address_line_2 !== "") {
				_payload = {
					..._payload,
					address_line_2: editContactInformation.address_line_2
				};
			}
			const response = await api.editMemberDetails.editMemberDetailsChangeRequest(_payload, member.id);

			if (response) {
				setMember(Object.assign({}, response));
				alert("Contact Request Sent Successfully!");
				window.location.reload();
			}
		} else {
			if (editContactInformation.address_line_1 !== "") {
				const newPayload = {
					field_name: "address_line_1",
					previous_value: member.address_line_1,
					change_value: editContactInformation.address_line_1,
					operation_type: "UPDATE"
				};
				payload.push(newPayload);
			}
			if (editContactInformation.address_line_2 !== "") {
				const newPayload = {
					field_name: "address_line_2",
					previous_value: member.address_line_2,
					change_value: editContactInformation.address_line_2,
					operation_type: "UPDATE"
				};
				payload.push(newPayload);
			}
			const JWT_LOC = localStorage.getItem("@jwt_member");
			const POST_API = `${url}:${port}/api/v1/change-request/personal`;
			// console.log("Debug --- (PAYLOAD) --- ", payload);
			const SSN = member.SSN;
			const res = await trackPromise(
				axios.post(POST_API, payload, {
					headers: {
						Authorization: `Bearer ${JWT_LOC}`
					},
					params: {
						SSN
					}
				})
			);
			// console.log("RESPONSE -- (FROM AXIOS) ", res);

			if (res.status === 200) {
				alert("Request Sent Successfully");
				// handleClose();
			} else {
				return alert("Something went wrong");
			}
		}

		// if (editContactInformation.address_line_1 !== "") {
		// 	const newPayload = {
		// 		field_name: "address_line_1",
		// 		previous_value: member.address_line_1,
		// 		change_value: editContactInformation.address_line_1,
		// 		operation_type: "UPDATE"
		// 	};
		// 	payload.push(newPayload);
		// }
		// if (editContactInformation.address_line_2 !== "") {
		// 	const newPayload = {
		// 		field_name: "address_line_2",
		// 		previous_value: member.address_line_2,
		// 		change_value: editContactInformation.address_line_2,
		// 		operation_type: "UPDATE"
		// 	};
		// 	payload.push(newPayload);
		// }
		// if (editContactInformation.email !== "") {
		// 	const newPayload = {
		// 		field_name: "email",
		// 		previous_value: member.email,
		// 		change_value: editContactInformation.email,
		// 		operation_type: "UPDATE"
		// 	};
		// 	payload.push(newPayload);
		// }
		// const JWT_LOC = localStorage.getItem("@jwt_member");
		// const POST_API = `${url}:${port}/api/v1/change-request/personal`;
		// // console.log("Debug --- (PAYLOAD) --- ", payload);
		// const SSN = member.SSN;
		// const res = await trackPromise(
		// 	axios.post(POST_API, payload, {
		// 		headers: {
		// 			Authorization: `Bearer ${JWT_LOC}`
		// 		},
		// 		params: {
		// 			SSN
		// 		}
		// 	})
		// );
		// // console.log("RESPONSE -- (FROM AXIOS) ", res);

		// if (res.status === 200) {
		// 	alert("Request Sent Successfully");
		// 	handleClose();
		// } else {
		// 	return alert("Something went wrong");
		// }
		handleClose();
	}, [editContactInformation, member, handleClose, isEnrollment, setMember]);

	const getEnrollmentGroupAndVEB = useCallback(async () => {
		const response = await trackPromise(api.enrollment.getEnrollmentGroupAndVEB());

		if (response) {
			const { openEnrollments, VEBOpenEnrollment } = response;
			// // console.log("openEnrollments", openEnrollments.length);
			// // console.log("VEBOpenEnrollment", VEBOpenEnrollment.length);

			if (openEnrollments.length != 0 || VEBOpenEnrollment != 0) {
				setIsEnrollment(true);
			} else {
				setIsEnrollment(false);
			}
		}
	}, []);

	// console.log("isEnrollment", isEnrollment);

	useEffect(() => {
		getEnrollmentGroupAndVEB();
	}, [getEnrollmentGroupAndVEB]);

	return (
		<div>
			<Dialog
				style={{ zIndex: 800 }}
				open={openDialog}
				onClose={handleClose}
				TransitionComponent={Transition}
				keepMounted
				aria-labelledby="form-dialog-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle className="title" style={{ color: theme.primary_color }}>
					{/* <div className="title" style={{ color: theme.primary_color }}> */}
					Edit Contact Information
				</DialogTitle>
				<DialogContent>
					<div className="profile-edit-dialog-container">
						{/* <div className="profile-edit-form-each">
							<div className="profile-edit-form-label">Email</div>
							<Suspense fallback={<div />}>
								<CustomInput
									name="email"
									value={editContactInformation.email}
									onChange={handleEditContactInformationChange}
								/>
							</Suspense>
						</div> */}

						<div className="profile-edit-form-each">
							<div className="profile-edit-form-label">Address Line 1</div>
							<Suspense fallback={<div />}>
								<CustomInput
									name="address_line_1"
									value={editContactInformation.address_line_1}
									onChange={handleEditContactInformationChange}
								/>
							</Suspense>
						</div>
						<div className="profile-edit-form-each">
							<div className="profile-edit-form-label">Address Line 2</div>
							<Suspense fallback={<div />}>
								<CustomInput
									name="address_line_2"
									value={editContactInformation.address_line_2}
									onChange={handleEditContactInformationChange}
								/>
							</Suspense>
						</div>
					</div>
				</DialogContent>
				<DialogActions className="profile-edit-dialog-action-button-container">
					{actions?.map((action, index) => {
						const { label, callback } = action;
						return (
							<Button
								variant="contained"
								key={index}
								onClick={callback}
								className="profile-edit-dialog-action-button"
								style={{
									backgroundColor: theme.button.background_color,
									color: theme.button.color
								}}
							>
								{label}
							</Button>
						);
					})}
					<Button
						variant="contained"
						onClick={handleEditContactSubmitClick}
						className="profile-edit-dialog-action-button"
						style={{
							backgroundColor: theme.button.background_color,
							color: theme.button.color
						}}
						disabled={
							editContactInformation.address_line_1 === "" && editContactInformation.address_line_2 === ""
								? // editContactInformation.email === ""
								// editContactInformation.address_line_2 === "" &&
								// editContactInformation.email === ""
								true
								: false
						}
					>
						{isEnrollment ? <span>Submit</span> : <span>Submit Request</span>}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default ContactEditDialog;
